<!--树形选择(单位管理专用)
	imgMethod:图标获取的方法，传回项，返回图片路径
	dataList:数据列表
	nowCheckId:当前选中的尾段节点的id,这个树是单选的
	getIdMethod:获取id的方法,返回一个唯一的字符串
	menuCheckedAble:是否允许选中菜单项,默认不允许
	margin:进行子集margin-left操作
	firstStageClass：第一级菜单加样式的暂时想法，第一级只有一个可以这样做，多个就会有问题，需要这个prop来确认是否开启样式
-->
<template>
	<div class="treeBody">
		<div class="treeItem" v-for="(item,index) in dataList" v-if="isEnable(item)">
			<div :style="getTextStyle(item)" class="tree-column" @click.stop="checkItem(item,index)" :key="getIdMethod(item)">
				<div class="sort">
					<img :style="getStyle(item)" class="state" :src="getStateImg(item)" />
					<img v-if="checkedShow" :src="getCheckedImg(item)" />
					<img class="tips" :src="imgMethod(item)" />
					<span :style="getTextStyle(item)">{{item.serialno}}</span>
				</div>
				<div class="permissionName"><span>{{item.rightname}}</span></div>
				<!--<div class="icon">{{item.icon}}</div>-->
				<div class="tag"><span>{{item.webpage}}</span></div>
				<!--<div class="remark">{{item.remark}}</div>-->
				<div class="enable">
					<span v-if="item.enable === 1">启用</span>
					<span v-if="item.enable === 0">禁用</span>
					<!--{{item.enable}}-->
				</div>
				<div class="createTime">
					<span v-if="item.createTime != '' && item.createTime != undefined">{{new Date(item.createTime).formatByTime('-')}}</span>
				</div>
			</div>
			<tree :checked="checked" :margin="marginLeft+10" :imgMethod="imgMethod" :getIdMethod="getIdMethod" :nowOpenFloorIds="nowOpenFloorIds" :nowCheckId="nowCheckId" :menuCheckedAble="menuCheckedAble" :dataList='item.next' v-if="hasNext(item)" v-show="isCheck(item)" @checkItem="threadCheck" :getEnableMethod="getEnableMethod" :getNameMethod="getNameMethod"></tree>
		</div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		name: 'tree',
		components: {},
		props: ["margin", "imgMethod", "dataList", "nowCheckId", "nowOpenFloorIds", "getIdMethod", "getNameMethod", "getEnableMethod", "menuCheckedAble", "checked"],
		data() {
			return {
				marginLeft: 0
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			checkedShow() {
				if(undefined == this.checked) {
					return false
				}
				return this.checked
			},
			getCheckedImg() {
				return item => {
					if(item.type == 'unit' || item.entityName == 'AppClassType' || (isempty(item.id) && isempty(item.url))) {
						return
					}
					if(this.getIdMethod(item) == undefined) {
						return resourcesStore.getters.getResourcesByName("checkBox/unchecked.png")
					}
					if(this.nowCheckId == this.getIdMethod(item)) {
						return resourcesStore.getters.getResourcesByName("checkBox/checked.png")
					}
					return resourcesStore.getters.getResourcesByName("checkBox/unchecked.png")
				}
			},
			getStyle() {
				this.getMargin()
				return item => {
					if(this.getIdMethod == undefined) {
						return
					}
					if(this.nowCheckId == this.getIdMethod(item)) {
						return {
							'margin-left': this.marginLeft + "px",
							color: '#2A82DE',
						}
					}
					return {
						'margin-left': this.marginLeft + "px"
					}
				}
			},
			getTextStyle() {
				return item => {
					if(this.getIdMethod != undefined && this.nowCheckId == this.getIdMethod(item)) {
						return {
							color: '#FFFFFF',
							'background-color': '#1E90FF'
						}
					}
				}
			}
		},
		watch: {},
		methods: {
			getMargin() {
				if(undefined == this.margin) {
					this.marginLeft = 10
				} else {
					this.marginLeft = this.margin
				}
			},
			getStateImg(item) {
				if(this.hasNext(item)) {
					return this.isCheck(item) ? resourcesStore.getters.getResourcesByName("tree/tree_open.png") : resourcesStore.getters.getResourcesByName("tree/tree_close.png")
				}
				return resourcesStore.getters.getResourcesByName("tree/tree_none.png")
			},
			isCheck(item) {
				return this.nowOpenFloorIds.includes(this.getIdMethod(item))
			},
			checkItem(item, index) {
				if(!this.hasNext(item)) {
					//如果是单独项就一级级上抛
					this.$emit("checkItem", item)
					return
				}
				var id = this.getIdMethod(item)
				var i = this.nowOpenFloorIds.indexOf(id)
				if(i == -1) {
					//选中了某项
					this.nowOpenFloorIds.push(id)
				} else {
					//取消了某项的选中
					this.nowOpenFloorIds.splice(i, 1)
				}
				if(this.menuCheckedAble == true) {
					//菜单也能选中的
					this.$emit("checkItem", item)
				}
			},
			threadCheck(item) {
				this.$emit("checkItem", item)
			},
			hasNext(item) {
				if(item.next == undefined || item.next.length == 0) {
					return false
				}
				//过滤掉不可用的
				if(this.getEnableMethod != undefined) {
					var enableList = item.next.filter(item => {
						return this.getEnableMethod(item)
					})
					if(enableList.length == 0) {
						return false
					}
				}
				return true
			},
			getName(item) {
				if(this.getNameMethod != undefined) {
					return this.getNameMethod(item)
				}
				return item.name
			},
			isEnable(item) {
				if(this.getEnableMethod != undefined) {
					return this.getEnableMethod(item)
				}
				return true
			}
		}
	}
</script>

<style scoped>
	.sort {
		border: 1px dashed #ccc;
		border-width: .01rem 0 0 .01rem;
		line-height: 38px;
		width: 15%;
	}
	
	.permissionName {
		border: 1px dashed #ccc;
		border-width: .01rem 0 0 .01rem;
		line-height: 38px;
		width: 15%;
	}
	
	.icon {
		border: 1px dashed #ccc;
		border-width: .01rem 0 0 .01rem;
		line-height: 38px;
		width: 15%;
	}
	
	.tag {
		border: 1px dashed #ccc;
		border-width: .01rem 0 0 .01rem;
		line-height: 38px;
		width: 30%;
	}
	
	.remark {
		border: 1px dashed #ccc;
		border-width: .01rem 0 0 .01rem;
		line-height: 38px;
		width: 15%;
	}
	
	.enable {
		border: 1px dashed #ccc;
		border-width: .01rem 0 0 .01rem;
		line-height: 38px;
		width: 15%;
	}
	
	.createTime {
		border: 1px dashed #ccc;
		border-width: .01rem 0 0 .01rem;
		line-height: 38px;
		width: 25%;
	}
	
	.tree-column {
		height: 38px;
		line-height: 38px;
		display: flex;
	}
	
	.treeBody {
		background-color: #F8F8F8;
	}
	
	.treeItem {
		white-space: nowrap;
		cursor: pointer;
		text-align: center;
	}
	
	.treeItem img.state {
		width: .1rem;
		height: .1rem;
		/* margin-left: 15px; */
		margin-left: 0px !important;
	}
	
	.treeItem img.tips {
		width: .15rem;
		height: .15rem;
		/* margin-left: 5px; */
	}
	
	.treeItem span {
		white-space: nowrap;
		line-height: .2rem;
		color: black;
	}
	
	.tree-column:active div {
		background-color: #0092dc;
	}
	
	.tree-column:hover div {
		background-color: rgba(0, 0, 0, 0.1);
	}
	
	.tree-column:nth-child(even) div {
		background-color: white;
	}
</style>